module.exports = __webpack_public_path__ + "static/media/1s.c3d2eeb3.jpg";